unit MenjavaGesla;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, MobileForm, Vcl.Grids, System.DateUtils, Constants;

type
  TfrmMenjavaGesla = class(TForm)
    btnCancel: TButton;
    btnOk: TButton;
    btnMenjava: TButton;
    edtPass1: TEdit;
    lblInfo: TLabel;
    edtPass2: TEdit;
    edtEmail: TEdit;
    procedure btnOkClick(Sender: TObject);
    procedure FormShow(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure btnMenjavaClick(Sender: TObject);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    { Private declarations }
    FMenjavaGesla: TGesloNacin;
    function CheckPodatki: boolean;
    procedure MarkInvalid(Control: TEdit; Invalid: boolean);
  public
    { Public declarations }
    property MenjavaGesla: TGesloNacin read FMenjavaGesla write FMenjavaGesla;
  protected procedure LoadDFMValues; override; end;

var
  frmMenjavaGesla: TfrmMenjavaGesla;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Auth.Service;

procedure TfrmMenjavaGesla.btnCancelClick(Sender: TObject);
begin
  frmMain.ShowNarocila;
end;

procedure TfrmMenjavaGesla.MarkInvalid(Control: TEdit; Invalid: boolean);
begin
  Control.ElementClassName := 'form-control';
  if Invalid then
    Control.ElementClassName := Control.ElementClassName+' is-invalid'
  else
    Control.ElementClassName := string(Control.ElementClassName).Replace(' is-invalid', '');
end;

procedure TfrmMenjavaGesla.btnMenjavaClick(Sender: TObject);
begin
  //Zamenjaj geslo

  if not CheckPodatki then begin
    exit;
  end;

//  ShowMEssage('Klic');

  modMain.MenjavaGesla(edtEmail.Text, edtPass1.Text);
end;

procedure TfrmMenjavaGesla.btnOkClick(Sender: TObject);
begin
  if not CheckPodatki then begin
    exit;
  end;

  // Shrani nalog
(*  modMain.Registriraj(
    edtEmail.Text,
    edtPass1.Text
  ); *)
end;

function TfrmMenjavaGesla.CheckPodatki: boolean;
var listErr: TStringList;

  function VsebujeStevilko(InTxt: string): boolean;
  var I: integer;
  begin
    Result := false;
    for I := 0 to InTxt.Length do begin
      if StrToIntDef(InTxt[I], -1) > -1 then begin
        Result := true;
        break;
      end;
    end;
  end;

begin
  {$REGION 'Check podatkov'}
  Result := false;

  MarkInvalid(edtEmail, false);
  MarkInvalid(edtPass1, false);
  MarkInvalid(edtPass2, false);

  listErr := TStringList.Create;

  if edtEMail.Text = '' then begin
    listErr.Add('Vpiši e-poštni naslov');
    MarkInvalid(edtEmail, true);
  end else if not string(edtEMail.Text).Contains('@') then begin
    listErr.Add('Neveljaven e-poštni naslov');
    MarkInvalid(edtEmail, true);
  end;

  if edtPass1.Text = '' then begin
    listErr.Add('Vpiši geslo');
    MarkInvalid(edtPass1, true);
  end else if string(edtPass1.Text).Length < 8 then begin
    listErr.Add('Prekratko geslo');
    MarkInvalid(edtPass1, true);
  end;

  if StrToIntDef(edtPass1.Text, -1) >= 0 then begin
    listErr.Add('Geslo ne vsebuje črk');
    MarkInvalid(edtPass1, true);
  end;

  if not VsebujeStevilko(edtPass1.Text) then begin
    listErr.Add('Geslo ne vsebuje številk');
    MarkInvalid(edtPass1, true);
  end;

  if string(edtPass2.Text).Trim = '' then begin
    listErr.Add('Vpiši potrditev gesla');
    MarkInvalid(edtPass2, true);
  end;

  if edtPass1.Text <> edtPass2.Text then begin
    listErr.Add('Gesli nista enaki');
    MarkInvalid(edtPass1, true);
  end;

  Result := listErr.Count < 1;

  if not Result then begin
    ShowMessage(listErr.Text);
  end;

  listErr.Free;
  {$ENDREGION}
end;

procedure TfrmMenjavaGesla.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmMenjavaGesla.FormShow(Sender: TObject);
begin
  inherited;
//  edtEmail.Enabled := not MenjavaGesla;

  btnOk.Enabled := FMenjavaGesla = gnRegistracija;
  btnMenjava.Enabled := FMenjavaGesla = gnMenjavaGesla;

  btnOk.Visible := btnOk.Enabled;
  btnMenjava.Visible := btnMenjava.Enabled;

  ApplyTheme(AppSettings.DarkMode);
end;

procedure TfrmMenjavaGesla.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblInfo := TLabel.Create('lblInfo');
  btnCancel := TButton.Create('btnCancel');
  btnOk := TButton.Create('btnOk');
  btnMenjava := TButton.Create('btnMenjava');
  edtPass1 := TEdit.Create('edtPass1');
  edtPass2 := TEdit.Create('edtPass2');
  edtEmail := TEdit.Create('edtEmail');

  lblInfo.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  btnMenjava.BeforeLoadDFMValues;
  edtPass1.BeforeLoadDFMValues;
  edtPass2.BeforeLoadDFMValues;
  edtEmail.BeforeLoadDFMValues;
  try
    Name := 'frmMenjavaGesla';
    Width := 640;
    Height := 480;
    Align := alClient;
    Color := clBtnFace;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'FormShow');
    lblInfo.SetParentComponent(Self);
    lblInfo.Name := 'lblInfo';
    lblInfo.Left := 193;
    lblInfo.Top := 164;
    lblInfo.Width := 985;
    lblInfo.Height := 37;
    lblInfo.Caption := 'Geslo mora biti dolgo najmanj 8 znakov, vsebovati pa mora vsaj 1 '#269'rko in 1 '#353'tevilko';
    lblInfo.Color := clBtnFace;
    lblInfo.ElementFont := efCSS;
    lblInfo.ElementPosition := epIgnore;
    lblInfo.HeightStyle := ssAuto;
    lblInfo.HeightPercent := 100.000000000000000000;
    lblInfo.WidthStyle := ssAuto;
    lblInfo.WidthPercent := 100.000000000000000000;
    btnCancel.SetParentComponent(Self);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 72;
    btnCancel.Top := 296;
    btnCancel.Width := 225;
    btnCancel.Height := 49;
    btnCancel.ChildOrder := 1;
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epIgnore;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnOk.SetParentComponent(Self);
    btnOk.Name := 'btnOk';
    btnOk.Left := 320;
    btnOk.Top := 296;
    btnOk.Width := 225;
    btnOk.Height := 49;
    btnOk.ChildOrder := 3;
    btnOk.ElementFont := efCSS;
    btnOk.ElementPosition := epIgnore;
    btnOk.HeightStyle := ssAuto;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.WidthStyle := ssAuto;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    btnMenjava.SetParentComponent(Self);
    btnMenjava.Name := 'btnMenjava';
    btnMenjava.Left := 72;
    btnMenjava.Top := 233;
    btnMenjava.Width := 225;
    btnMenjava.Height := 48;
    btnMenjava.ChildOrder := 2;
    btnMenjava.ElementFont := efCSS;
    btnMenjava.ElementPosition := epIgnore;
    btnMenjava.HeightStyle := ssAuto;
    btnMenjava.HeightPercent := 100.000000000000000000;
    btnMenjava.WidthStyle := ssAuto;
    btnMenjava.WidthPercent := 100.000000000000000000;
    SetEvent(btnMenjava, Self, 'OnClick', 'btnMenjavaClick');
    edtPass1.SetParentComponent(Self);
    edtPass1.Name := 'edtPass1';
    edtPass1.Left := 193;
    edtPass1.Top := 133;
    edtPass1.Width := 96;
    edtPass1.Height := 25;
    edtPass1.ChildOrder := 3;
    edtPass1.ElementFont := efCSS;
    edtPass1.ElementPosition := epIgnore;
    edtPass1.HeightStyle := ssAuto;
    edtPass1.HeightPercent := 100.000000000000000000;
    edtPass1.WidthStyle := ssAuto;
    edtPass1.WidthPercent := 100.000000000000000000;
    edtPass2.SetParentComponent(Self);
    edtPass2.Name := 'edtPass2';
    edtPass2.Left := 320;
    edtPass2.Top := 133;
    edtPass2.Width := 96;
    edtPass2.Height := 25;
    edtPass2.ChildOrder := 5;
    edtPass2.ElementFont := efCSS;
    edtPass2.ElementPosition := epIgnore;
    edtPass2.HeightStyle := ssAuto;
    edtPass2.HeightPercent := 100.000000000000000000;
    edtPass2.WidthStyle := ssAuto;
    edtPass2.WidthPercent := 100.000000000000000000;
    edtEmail.SetParentComponent(Self);
    edtEmail.Name := 'edtEmail';
    edtEmail.Left := 193;
    edtEmail.Top := 80;
    edtEmail.Width := 96;
    edtEmail.Height := 25;
    edtEmail.ChildOrder := 6;
    edtEmail.ElementFont := efCSS;
    edtEmail.ElementPosition := epIgnore;
    edtEmail.HeightStyle := ssAuto;
    edtEmail.HeightPercent := 100.000000000000000000;
    edtEmail.WidthStyle := ssAuto;
    edtEmail.WidthPercent := 100.000000000000000000;
  finally
    lblInfo.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    btnMenjava.AfterLoadDFMValues;
    edtPass1.AfterLoadDFMValues;
    edtPass2.AfterLoadDFMValues;
    edtEmail.AfterLoadDFMValues;
  end;
end;

end.
